import {
  pricingTranslationsDe,
  featuresSectionDe,
  footerExtendedDe,
  organizationsDe,
  b2bContactDe,
  signInDe,
  a11yDe,
} from './marketingCopy.de'
import { accountAdminCopyDe } from './accountAdminCopy/accountAdminCopy.de'

export const de = {
  hero: {
    title: 'Zporti',
    subtitle:
      'Fordere deine Freunde heraus. Vorhersage das Spiel. Gewinne zusammen.',
    description:
      'Erstelle Sportvorhersage-Herausforderungen mit Freunden, verfolge deine Siege und konkurriere in der Bestenliste. Die ultimative Plattform für freundschaftliche Wettbewerbe und Sportvorhersagen.',
  },
  siteNav: {
    home: 'Start',
    organizations: 'Organisationen',
    contact: 'Kontakt',
    packs: 'Preise',
    signIn: 'Anmelden',
    createAccount: 'Registrieren',
    openApp: 'App öffnen',
    signedInAs: 'Angemeldet als',
    signedInNameFallback: 'Ihr Konto',
    signOut: 'Abmelden',
    signOutConfirmTitle: 'Abmelden?',
    signOutConfirmMessage: 'Sie müssen sich erneut anmelden, um auf Ihr Konto zuzugreifen.',
    signOutConfirm: 'Abmelden',
    signOutCancel: 'Abbrechen',
    signOutErrorTitle: 'Fehler',
    signOutError: 'Abmelden fehlgeschlagen. Bitte erneut versuchen.',
  },
  features: {
    title: 'Warum Zporti?',
    subtitle:
      'Alles, was du brauchst, um Sportvorhersagen in freundschaftliche Wettbewerbe zu verwandeln',
    challenge: {
      title: 'Freunde Herausfordern',
      description:
        'Erstelle benutzerdefinierte Vorhersage-Herausforderungen und lade deine Freunde zum Wettbewerb ein. Richte Gruppen-Herausforderungen ein oder tritt einzeln gegen Freunde an.',
    },
    track: {
      title: 'Ergebnisse Verfolgen',
      description:
        'Sieh Echtzeit-Ergebnisse, verfolge deine Vorhersagen und überwache deine Gewinnrate. Erhalte sofortige Benachrichtigungen, wenn Spielergebnisse eintreffen.',
    },
    compete: {
      title: 'Wettbewerben und Gewinnen',
      description:
        'Steige in der Bestenliste auf, verdiene Angeberrechte und sieh, wer der beste Vorhersager ist. Feiere Siege und verfolge deinen Fortschritt im Laufe der Zeit.',
    },
    groups: {
      title: 'Gruppen & Spieltage',
      description:
        'Dieselben Freunde über viele Spieltage, Gruppen-Ranglisten im Blick und Challenges mit Liga-Gefühl—nicht nur ein Einzelspiel.',
    },
    locks: {
      title: 'Tipps bis zum Anpfiff',
      description:
        'Tipps sperren beim Anpfiff: gleiche Regeln für alle. Ergebnisse folgen offiziellen Spielständen—fair und ohne Streit.',
    },
    organizations: {
      title: 'Organisationen & Branding',
      description:
        'Vereine, Unternehmen und Partner können eigene Farben, Logos und Mitgliedsplätze nutzen—eure Community wirkt wie ihr in der App.',
    },
    avatars: featuresSectionDe.avatars,
  },
  featuresSection: featuresSectionDe,
  howItWorks: {
    title: 'Wie es Funktioniert',
    subtitle: 'Beginne in drei einfachen Schritten',
    step1: {
      title: 'Eine Herausforderung Erstellen',
      description:
        'Wähle ein Spiel, setze deine Vorhersagen und lade Freunde ein, sich deiner Herausforderung anzuschließen.',
    },
    step2: {
      title: 'Vorhersagen Treffen',
      description:
        'Jeder Teilnehmer macht seine Vorhersagen, bevor das Spiel beginnt. Sperre deine Auswahl und warte auf die Action.',
    },
    step3: {
      title: 'Sehen, Wer Gewinnt',
      description:
        'Ergebnisse werden automatisch berechnet, wenn Spiele enden. Feiere Siege und steige in der Bestenliste auf.',
    },
  },
  competition: {
    title: 'Freundschaftlicher Wettbewerb, Echte Aufregung',
    description:
      'Erlebe den Nervenkitzel von Sportvorhersagen mit deinen Freunden. Ob du ein gelegentlicher Fan oder ein Statistik-Enthusiast bist, Zporti macht jedes Spiel aufregender. Fordere deine Freunde heraus, beweise deine Vorhersagefähigkeiten und sieh, wer als Sieger hervorgeht.',
  },
  stats: {
    challenges: 'Aktive Herausforderungen',
    users: 'Aktive Benutzer',
    predictions: 'Getroffene Vorhersagen',
    games: 'Verfolgte Spiele',
  },
  benefits: {
    title: 'Warum Zporti Wählen?',
    subtitle:
      'Alles, was du für die ultimative Sportvorhersage-Erfahrung brauchst',
    realTime: {
      title: 'Echtzeit-Updates',
      description:
        'Erhalte sofortige Benachrichtigungen, wenn Spiele beginnen, Ergebnisse aktualisiert werden und Ergebnisse eintreffen. Verpasse nie einen Moment mit Live-Ergebnisverfolgung und automatischen Ergebnisberechnungen.',
    },
    social: {
      title: 'Sozial und Verbunden',
      description:
        'Verbinde dich mit Freunden über Gmail, lade sie einfach ein und baue dein Vorhersage-Netzwerk auf. Erstelle Gruppen-Herausforderungen oder tritt einzeln gegen deine engsten Freunde an.',
    },
    smart: {
      title: 'Intelligente Vorhersagen',
      description:
        'Verfolge Quoten, analysiere Spieldaten und treffe fundierte Vorhersagen. Sieh dir historische Leistungen, Gewinnraten und detaillierte Statistiken an, um deine Vorhersagefähigkeiten zu verbessern.',
    },
    fair: {
      title: 'Fair und Transparent',
      description:
        'Alle Ergebnisse werden automatisch berechnet, wenn Spiele enden. Keine Streitigkeiten, keine manuelle Wertung - nur faire Wettbewerbe und klare Gewinner.',
    },
  },
  faq: {
    title: 'Häufig Gestellte Fragen',
    subtitle: 'Alles, was du über Zporti wissen musst',
    q1: {
      question: 'Wie lade ich Freunde ein?',
      answer:
        'Du kannst Freunde auf zwei Arten einladen: Verbinde dein Gmail-Konto, um Kontakte einfach auszuwählen, oder gib E-Mail-Adressen manuell ein. Freunde erhalten einen Einladungslink, um deiner Herausforderung beizutreten.',
    },
    q2: {
      question: 'Wann werden Vorhersagen gesperrt?',
      answer:
        'Vorhersagen müssen vor Spielbeginn gemacht werden. Sobald ein Spiel beginnt, werden alle Vorhersagen gesperrt und können nicht mehr geändert werden. Dies gewährleistet fairen Wettbewerb für alle.',
    },
    q3: {
      question: 'Wie werden Gewinner bestimmt?',
      answer:
        'Gewinner werden automatisch berechnet, wenn Spiele enden. Das System vergleicht alle Vorhersagen mit den tatsächlichen Spielergebnissen und aktualisiert die Bestenlisten in Echtzeit.',
    },
    q4: {
      question: 'Kann ich Gruppen-Herausforderungen erstellen?',
      answer:
        'Ja! Du kannst Herausforderungen mit mehreren Freunden erstellen oder einzeln gegen einzelne Freunde antreten. Richte Gruppenwettbewerbe ein, um zu sehen, wer die besten Vorhersagefähigkeiten hat.',
    },
  },
  packsPage: {
    pageTitle: 'Pläne & Preise',
  },
  contact: {
    title: 'Kontakt',
    subtitle:
      'Fragen zum Produkt, Feedback, Presse oder Partnerschaften—schreib uns unten oder direkt per E-Mail. Wir lesen jede Nachricht.',
    emailLabel: 'Schreibe uns eine E-Mail an',
    email: 'info@zporti.com',
    form: {
      nameLabel: 'Name',
      emailLabel: 'E-Mail',
      messageLabel: 'Nachricht',
      submitButton: 'Nachricht Senden',
      submitting: 'Wird gesendet...',
      successMessage:
        'Vielen Dank! Deine Nachricht wurde gesendet. Wir werden uns bald bei dir melden.',
      errorMessage:
        'Nachricht konnte nicht gesendet werden. Bitte versuche es später erneut.',
      namePlaceholder: 'Vor- und Nachname',
      emailPlaceholder: 'deine.email@beispiel.com',
      messagePlaceholder: 'Teile uns mit, was dir auf dem Herzen liegt...',
      validation: {
        nameRequired: 'Name ist erforderlich',
        nameTooLong: 'Der Name muss 50 Zeichen oder weniger haben',
        emailRequired: 'E-Mail ist erforderlich',
        emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
        messageRequired: 'Nachricht ist erforderlich',
        messageTooLong: 'Die Nachricht muss 500 Zeichen oder weniger haben',
        invalidCharacters:
          'Ungültige Zeichen erkannt. Bitte entferne alle speziellen Formatierungen.',
      },
    },
  },
  footer: {
    title: 'Bereit zum Starten?',
    subtitle:
      'Tritt Zporti heute bei und beginne, deine Freunde herauszufordern. Erstelle deine erste Vorhersage-Herausforderung in Sekunden.',
    privacyPolicy: 'Datenschutzerklärung',
    termsOfService: 'Nutzungsbedingungen',
    dataDeletion: 'Datenlöschung',
    credits: 'Credits',
    privacyControls: 'Datenschutz-Einstellungen',
    ...footerExtendedDe,
  },
  pricing: pricingTranslationsDe,
  organizations: organizationsDe,
  b2bContact: b2bContactDe,
  signIn: signInDe,
  a11y: a11yDe,
  accountAdmin: accountAdminCopyDe,
  legal: {
    backToHome: 'Zurück zur Startseite',
    backToPrivacyAndData: 'Zurück',
    privacyDocumentTitle: 'Datenschutzerklärung',
    dataDeletionDocumentTitle: 'Anleitung zur Datenlöschung',
    termsDocumentTitle: 'Nutzungsbedingungen',
    creditsDocumentTitle: 'Credits',
    aboutDocumentTitle: 'Über Zporti',
    supportDocumentTitle: 'Support',
    documentVersionLine: 'Zuletzt aktualisiert {date} · Version {version}',
    privacyControlsCallout:
      'Möchtest du Einwilligungen ändern oder eine Kopie deiner Daten anfordern? Öffne die Datenschutz-Einstellungen in deinem Konto.',
    openPrivacyControls: 'Datenschutz-Einstellungen öffnen',
    signInForPrivacyControls: 'Melden Sie sich an, um die Datenschutz-Einstellungen zu öffnen',
  },
  privacyControls: {
    title: 'Datenschutz-Einstellungen',
    subtitle: 'Verwalte Marketing-Einwilligungen und fordere eine Kopie deiner Kontodaten an.',
    marketingEmailsTitle: 'Marketing-E-Mails',
    marketingEmailsHint: 'Du kannst deine Einwilligung jederzeit erteilen oder widerrufen.',
    analyticsTrackingTitle: 'Analytics-Tracking',
    analyticsTrackingHint: 'Aktiviere oder deaktiviere Analytics-Tracking für dieses Gerät/diesen Browser.',
    accountDataCopyTitle: 'Kontodaten-Kopie',
    accountDataCopyHint:
      'Lade eine JSON-Kopie personenbezogener Daten herunter, die mit deinem Konto verknüpft sind (einmal alle 24 Stunden verfügbar).',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    downloadMyData: 'Meine Daten herunterladen',
    nextExportAvailable: 'Nächster Export verfügbar',
    close: 'Schließen',
    deleteYourAccount: 'Konto löschen',
    deleteYourAccountHint:
      'Bestätige auf dem nächsten Bildschirm. Dadurch werden dein Konto und zugehörige Daten dauerhaft entfernt.',
  },
}
